import http from "../http-common"

const adminAll = (page, pageSize, search, orderBy, orderDirection, filters) => {
    const params = new URLSearchParams({
        page: page || 0,
        pageSize: pageSize || 1000,
        search: search || '',
        orderBy: orderBy || 'time',
        orderDirection: orderDirection || 'DESC',
        filters: JSON.stringify(filters || {})
    });
    return http.get(`/v1/entries?${params.toString()}`)
}

const getAll = (loc, page, pageSize, search, orderBy, orderDirection, filters) => {
    const params = new URLSearchParams({
        page: page || 0,
        pageSize: pageSize || 50,
        search: search || '',
        orderBy: orderBy || 'time',
        orderDirection: orderDirection || 'DESC',
        filters: JSON.stringify(filters || {})
    });
    return http.get(`/v1/entries/loc/${loc}?${params.toString()}`)
}

const adminAllToday = () => {
    return http.get(`/v1/entries/allToday`)
}

const getAllToday = loc => {
    return http.get(`/v1/entries/allToday/loc/${loc}`)
}

const adminCountToday = () => {
    return http.get(`/v1/entries/countToday`)
}

const adminAllDateFilter = (startDate, endDate) => {
    return http.get(`/v1/entries/start/${startDate}/end/${endDate}`)
}

const getAllDateFilter = (loc, startDate, endDate) => {
    return http.get(`/v1/entries/loc/${loc}/start/${startDate}/end/${endDate}`)
}

const adminFourHour = () => {
    return http.get(`/v1/entries/fourHour`)
}

const fourHour = loc => {
    return http.get(`/v1/entries/fourHour/loc/${loc}`)
}

const get = id => {
    return http.get(`/v1/entries/${id}`)
}

const create = data => {
    return http.post("/v1/entries", data)
}

const update = (id, data) => {
    return http.put(`/v1/entries/${id}`, data)
}

const remove = id => {
    return http.delete(`/v1/entries/${id}`)
}

const removeAll = () => {
    return http.delete(`/v1/entries`)
}

const countToday = loc => {
    return http.get(`/v1/entries/countToday/loc/${loc}`)
}

export default {
    adminAll,
    adminAllToday,
    adminCountToday,
    adminFourHour,
    adminAllDateFilter,
    getAllDateFilter,
    fourHour,
    getAll,
    getAllToday,
    get,
    create,
    update,
    remove,
    removeAll,
    countToday,
}
